import React from 'react';
import { Table } from 'react-bootstrap';
import THead from "./components/THead";
import Row from "./components/Row";
import TotalRow from './components/TotalRow';
import { sortArray } from "../../../../Utils";
import { calculateECost } from "../../prepareReport";

const PeriodTable = ({ reportObj, countries, device, sortParam, sortOrder, onSortChange }) => {
    const { report } = reportObj;
    const rowsData = getRowsData(report, countries, device);
    const total = calcTotal(rowsData);

    if(sortParam) sortArray(rowsData, sortParam, sortOrder);
    const rows = rowsData.map(row => <Row {...row} key={row.country}/>);

    return (
        <Table bordered responsive>
            <THead onSortChange={onSortChange}/>
            <tbody>
                <TotalRow {...total} />
                {rows}
            </tbody>
        </Table>
    )
};

function calcTotal(data) {
    const totals = data.reduce((obj, { spends, conversions }) => {
        if(spends) obj.spends += spends;
        if(conversions) obj.conversions += conversions;

        return obj;
    }, { spends: 0, conversions: 0 });

    totals.eCost = calculateECost(totals.spends, totals.conversions);

    return totals;
}

function getRowsData(report, countries, device) {
    return report.reduce((arr, row) => {
        let isMatchFilters = true;


        if(countries.length && countries.indexOf(row.country) === -1) isMatchFilters = false;
        else if(device && device !== row.device) isMatchFilters = false;

        if(isMatchFilters) arr.push(row);

        return arr;
    }, []);
}

export default PeriodTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderECostCountry/components/PeriodTable/index.js